import { axiosPost } from '../ServiceBase';

export const getProtesisTramitesIniciadosAutorizados = async (data) => {
  const response = await axiosPost(
    '/v1/busquedas/protesis-tablero/protesis',
    data,
  );
  return response;
};

export const getProtesisTramitesPorDelegacion = async (data) => {
  const response = await axiosPost(
    '/v1/busquedas/protesis-tablero/protesis-por-sede',
    data,
  );
  return response;
};

export const getProtesisTramitesPorAuditor = async (data) => {
  const response = null;
  return response;
};
